import React from "react";
import "./associationInfoBox.scss";

import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";

import ClickableImageWithModal from "../../components/clickableImageWithModal/ClickableImageWithModal";

import { Button, Stack } from "react-bootstrap";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "../../utils/validation";

const AssociationInfoBox = ({
  id,
  name,
  address,
  image,
  dashboard = false,
  callback = () => {},
}) => {
  const navigate = useNavigate();
  return (
    <div className="container-association-info-box p-3">
      <Stack
        className="d-flex justify-content-between align-items-center"
        gap={0}
      >
        <Stack direction="horizontal" gap={3}>
          <ClickableImageWithModal
            src={image ? image : "/no_img.png"}
            alt="logo"
            style={{
              borderRadius: 15,
              height: 100,
              width: 100,
              objectFit: "cover",
            }}
          />
          <Stack
            className="stack-association-info"
            gap={1}
            onClick={() => {
              if (dashboard) callback();
              else navigate("/association/" + id);
            }}
          >
            <span className="name-association">{name}</span>
            {!isEmpty(address) ? (
              <Stack
                gap={1}
                direction="horizontal"
                className="d-flex align-items-center address-association"
              >
                <RoomOutlinedIcon />
                <span>{address}</span>
              </Stack>
            ) : null}
          </Stack>
        </Stack>

        <div className="cta-association-info-box w-100 d-flex justify-content-end aling-items-end">
          {dashboard ? (
            <Button
              variant="success"
              style={{ borderRadius: 25 }}
              onClick={() => callback()}
            >
              {t("common.manage")}
            </Button>
          ) : (
            <a href={"/association/" + id}>
              {t("common.view_association")}{" "}
              <ArrowForwardIosOutlinedIcon style={{ width: 15, height: 15 }} />
            </a>
          )}
        </div>
      </Stack>
    </div>
  );
};

export default AssociationInfoBox;
